import { render, staticRenderFns } from "./DocumentRevisionHistoryDialog.vue?vue&type=template&id=a47ca536&"
import script from "./DocumentRevisionHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentRevisionHistoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports